import { useEffect, useState } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { hasAdviseView, hasFeatureAccess } from '../../../store/User';
import { FEATURE_ROLES } from '../../../store/Role';
import { getFeatureFlagSubject } from '../../../Api/useFeatureFlags';

type Feature = keyof typeof FEATURE_ROLES;

const RECORD_FEATURES: Record<string, Feature> = {
  inventory: 'inventory',
  'workflow-order': 'inventory',
  support: 'cases'
};

const goHome = (
  <Navigate
    to={'/'}
    replace
  />
);

export const FeatureRoute = ({ feature }: { feature: Feature }) => (hasFeatureAccess(feature) ? <Outlet /> : goHome);

export const RecordRoute = () => {
  const feature = RECORD_FEATURES[useParams().type || ''];
  return !feature || hasFeatureAccess(feature) ? <Outlet /> : goHome;
};

const useAdviseEnabled = (): boolean => {
  // Read the current value up front, so a user being redirected never mounts Home and fires its requests.
  const [enabled, setEnabled] = useState(() => !!getFeatureFlagSubject().getValue().advise);
  useEffect(() => {
    const sub = getFeatureFlagSubject().subscribe((flags) => setEnabled(!!flags.advise));
    return () => sub.unsubscribe();
  }, []);
  return enabled;
};

// Home is built around inventory, so an Advise user without it starts in Advise instead.
export const HomeRoute = () =>
  useAdviseEnabled() && !hasFeatureAccess('inventory') && hasAdviseView() ? (
    <Navigate
      to={'/advise'}
      replace
    />
  ) : (
    <Outlet />
  );
